import PropTypes from 'prop-types';
import NtaPostSubmitPage from './NtaPostSubmitPage';
import { PostSubmitButton, PostSubmitMessage } from './NtaPostSubmit.styles';

const NtaSubmitSuccessPage = ({ onViewResult }) => (
  <NtaPostSubmitPage>
    <PostSubmitMessage>Thank you, Submitted Successfully!</PostSubmitMessage>
    <PostSubmitButton type="button" $width="177px" onClick={onViewResult}>
      VIEW RESULT
    </PostSubmitButton>
  </NtaPostSubmitPage>
);

NtaSubmitSuccessPage.propTypes = {
  onViewResult: PropTypes.func.isRequired
};

export default NtaSubmitSuccessPage;
